import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import {
  FaImages,  
  FaArrowRight,
  FaChevronLeft,
  FaChevronRight,
  FaSearchPlus,
  FaTimes,
} from 'react-icons/fa';
import './Gallery.css';

/* Existing photos */
import awards1     from '../../assets/images/awards1.png';
import icone       from '../../assets/images/icone.png';

/* New albums */
import pwaniUni1     from '../../assets/images/pwani-university-1.jpeg';
import pwaniUni2     from '../../assets/images/pwani-university-2.jpeg';
import pwaniUni3     from '../../assets/images/pwani-university-3.jpeg';
import pwaniUni4    from '../../assets/images/pwani-university-4.jpeg';
import pwaniUni5    from '../../assets/images/pwani-university-5.jpeg';
import pwaniUni6    from '../../assets/images/pwani-university-6.jpeg';
import pwaniUni7    from '../../assets/images/pwani-university-7.jpeg';
import pwaniUni8    from '../../assets/images/pwani-university-8.jpeg';
import pwaniUni9 from '../../assets/images/pwani-university-9.jpeg';
import pwaniUni10 from '../../assets/images/pwani-university-10.jpeg';
import pwaniUni11 from '../../assets/images/pwani-university-11.jpeg';
import pwaniUni12 from '../../assets/images/pwani-university-12.jpeg';
import pwaniUni13 from '../../assets/images/pwani-university-13.jpeg';
import pwaniUni14 from '../../assets/images/pwani-university-14.jpeg';
import pwaniUni15 from '../../assets/images/pwani-university-15.jpeg';
import pwaniUni16 from '../../assets/images/pwani-university-16.jpeg';
import pwaniUni17 from '../../assets/images/pwani-university-17.jpeg';
import pwaniUni18 from '../../assets/images/pwani-university-18.jpeg';
import pwaniUni19 from '../../assets/images/pwani-university-19.jpeg';
import pwaniUni20 from '../../assets/images/pwani-university-20.jpeg';
import youthSession1 from '../../assets/images/youth-session-1.jpeg';
import youthSession2 from '../../assets/images/youth-session-2.jpeg';
import youthSession3 from '../../assets/images/youth-session-3.jpeg';
import youthSession4 from '../../assets/images/youth-session-4.jpeg';
import youthSession5 from '../../assets/images/youth-session-5.jpeg';
import youthSession6 from '../../assets/images/youth-session-6.jpeg';
import youthSession7 from '../../assets/images/youth-session-7.jpeg';
import youthSession8 from '../../assets/images/youth-session-8.jpeg';
import youthSession9 from '../../assets/images/youth-session-9.jpeg';
import youthSession10 from '../../assets/images/youth-session-10.jpeg';
import youthSession11 from '../../assets/images/youth-session-11.jpeg';
import youthSession12 from '../../assets/images/youth-session-12.jpeg';
import youthSession13 from '../../assets/images/youth-session-13.jpeg';
import youthSession14 from '../../assets/images/youth-session-14.jpeg';
import youthSession15 from '../../assets/images/youth-session-15.jpeg';
import youthSession16 from '../../assets/images/youth-session-16.jpeg';
import youthSession17 from '../../assets/images/youth-session-17.jpeg';
import youthSession18 from '../../assets/images/youth-session-18.jpeg';
import youthSession19 from '../../assets/images/youth-session-19.jpeg';
import youthSession20 from '../../assets/images/youth-session-20.jpeg';
import youthSession21 from '../../assets/images/youth-session-21.jpeg';
import youthSession22 from '../../assets/images/youth-session-22.jpeg';
import youthSession23 from '../../assets/images/youth-session-23.jpeg';
import facilitation1 from '../../assets/images/facilitation-1.jpeg';
import facilitation2 from '../../assets/images/facilitation-2.jpeg';
import facilitation3 from '../../assets/images/facilitation-3.jpeg';
import facilitation4 from '../../assets/images/facilitation-4.jpeg';
import facilitation5 from '../../assets/images/facilitation-5.jpeg';
import facilitation6 from '../../assets/images/facilitation-6.jpeg';
import facilitation7 from '../../assets/images/facilitation-7.jpeg';
import facilitation8 from '../../assets/images/facilitation-8.jpeg';
import facilitation9 from '../../assets/images/facilitation-9.jpeg';
import facilitation10 from '../../assets/images/facilitation-10.jpeg';
import activities1     from '../../assets/images/activities-1.jpeg';
import activities2     from '../../assets/images/activities-2.jpeg';
import activities3     from '../../assets/images/activities-3.jpeg';
import activities4     from '../../assets/images/activities-4.jpeg';
import activities5     from '../../assets/images/activities-5.jpeg';
import activities6     from '../../assets/images/activities-6.jpeg';
import activities7     from '../../assets/images/activities-7.jpeg';
import activities8     from '../../assets/images/activities-8.jpeg';
import activities9     from '../../assets/images/activities-9.jpeg';

/* Category config */
const CATEGORIES = [
  { id: 'all',          label: 'All Photos'    },
  { id: 'activities',   label: 'Activities'   },
  { id: 'training',     label: 'Training'      },
  { id: 'campus',       label: 'Campus Talks'  },
  { id: 'youth',        label: 'Youth Programmes' },
  { id: 'facilitation', label: 'Facilitation'  },
  { id: 'awards',       label: 'Awards'        },
];

/* Static gallery items */
const ALL_PHOTOS = [
    {
    id:          1,
    featured:    false,
    images:      [activities1, activities2, activities3, activities4, activities5, activities6, activities7, activities8, activities9],
    category:    'activities',
    title:       'NSK Activities & Events',
    description: 'Over 200 nuclear scientists, engineers, policymakers and students gathered at the Kenyatta International Convention Centre for Kenya\'s premier nuclear science event.',
    date:        'September 2025',
  },
    
  {
    id:          2,
    featured:    false,
    images:      [pwaniUni1, pwaniUni2, pwaniUni3, pwaniUni4, pwaniUni5, pwaniUni6, pwaniUni7, pwaniUni8, pwaniUni9, pwaniUni10, pwaniUni11, pwaniUni12, pwaniUni13, pwaniUni14, pwaniUni15, pwaniUni16, pwaniUni17, pwaniUni18, pwaniUni19, pwaniUni20],
    category:    'campus',
    title:       'Pwani University Student Engagement',
    description: 'NSK speakers addressed a packed hall of Pwani University students on nuclear science and career pathways, closing with an open Q&A session.',
    date:        '2025',
  },
  {
    id:          3,
    featured:    false,
    images:      [youthSession1, youthSession2, youthSession3, youthSession4, youthSession5, youthSession6, youthSession7, youthSession8, youthSession9, youthSession10, youthSession11, youthSession12, youthSession13, youthSession14, youthSession15, youthSession16, youthSession17, youthSession18, youthSession19, youthSession20, youthSession21, youthSession22, youthSession23],
    category:    'youth',
    title:       'Youth Nuclear Science Engagement Session',
    description: 'Young people gathered in a session hall to learn about nuclear science, ask questions, and explore future opportunities in the field.',
    date:        '2025',
  },
  {
    id:          4,
    featured:    false,
    images:      [facilitation1, facilitation2, facilitation3, facilitation4, facilitation5, facilitation6, facilitation7, facilitation8, facilitation9, facilitation10],
    category:    'facilitation',
    title:       'NSK Facilitators in Action',
    description: 'A look at NSK facilitators leading sessions, guiding discussions, and supporting participants across our programmes.',
    date:        '2025',
  }, 
  {
    id:          5,
    featured:    false,
    images:      [awards1],
    category:    'awards',
    title:       'NSK Excellence Awards 2025',
    description: 'The annual NSK Excellence Awards recognised outstanding contributions to nuclear science in Kenya, honouring researchers, educators, and young professionals.',
    date:        'March 2025',
  },
  
  {
    id:          6,
    featured:    false,
    images:      [icone],
    category:    'activities',
    title:       'Icone — Nairobi, Kenya',
    description: 'NSK co-hosted the inaugural East Africa Nuclear Energy Forum, bringing together stakeholders from across the region.',
    date:        'March 2026',
  },
];

/* Lightbox Component */
function Lightbox({ photo, onClose }) {
  const [imageIndex, setImageIndex] = useState(0);
  const images = photo.images;
  const hasPrev = imageIndex > 0;
  const hasNext = imageIndex < images.length - 1;

  const goPrevImage = useCallback(() => {
    setImageIndex(i => (i > 0 ? i - 1 : i));
  }, []);

  const goNextImage = useCallback(() => {
    setImageIndex(i => (i < images.length - 1 ? i + 1 : i));
  }, [images.length]);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape')     onClose();
      if (e.key === 'ArrowLeft')  goPrevImage();
      if (e.key === 'ArrowRight') goNextImage();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [onClose, goPrevImage, goNextImage]);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  return (
    <div
      className="lightbox"
      role="dialog"
      aria-modal="true"
      aria-label={`Photo: ${photo.title}`}
    >
      <div
        className="lightbox__backdrop"
        onClick={onClose}
        aria-label="Close lightbox"
      />

      <div className="lightbox__content">
        <button
          className="lightbox__close"
          onClick={onClose}
          aria-label="Close lightbox"
        >
          <FaTimes size={16} />
        </button>

        {/* Current photo in the album, with in-album prev/next controls */}
        <div
          className="lightbox__image"
          style={{
            backgroundImage:    `url(${images[imageIndex]})`,
            backgroundSize:     'cover',
            backgroundPosition: 'center',
            backgroundRepeat:   'no-repeat',
          }}
          role="img"
          aria-label={`${photo.title} — photo ${imageIndex + 1} of ${images.length}`}
        >
          <div
            style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(0,0,0,0.35)' }}
            aria-hidden="true"
          />

          {images.length > 1 && (
            <>
              <button
                className="lightbox__image-nav lightbox__image-nav--prev"
                onClick={goPrevImage}
                disabled={!hasPrev}
                aria-label="Previous photo in this album"
              >
                <FaChevronLeft size={18} />
              </button>
              <button
                className="lightbox__image-nav lightbox__image-nav--next"
                onClick={goNextImage}
                disabled={!hasNext}
                aria-label="Next photo in this album"
              >
                <FaChevronRight size={18} />
              </button>
              <span className="lightbox__image-counter">
                {imageIndex + 1} / {images.length}
              </span>
            </>
          )}
        </div>

        {/* Thumbnail strip for jumping directly to a photo in this album */}
        {images.length > 1 && (
          <div className="lightbox__thumbs" role="tablist" aria-label="Photos in this album">
            {images.map((img, i) => (
              <button
                key={i}
                type="button"
                role="tab"
                aria-selected={i === imageIndex}
                className={`lightbox__thumb${i === imageIndex ? ' active' : ''}`}
                style={{ backgroundImage: `url(${img})` }}
                onClick={() => setImageIndex(i)}
                aria-label={`Go to photo ${i + 1}`}
              />
            ))}
          </div>
        )}

        <div className="lightbox__info">
          <span className="lightbox__tag">
            {CATEGORIES.find(c => c.id === photo.category)?.label}
          </span>
          <h2 className="lightbox__title">{photo.title}</h2>
          <p className="lightbox__description">{photo.description}</p>

          <div className="lightbox__meta">
            <time className="lightbox__date">
              {photo.date} · {images.length} photo{images.length === 1 ? '' : 's'}
            </time>
          </div>
        </div>
      </div>
    </div>
  );
}

/* GALLERY PAGE */
function Gallery() {
  const [activeCategory, setActiveCategory] = useState('all');
  const [selectedPhoto,  setSelectedPhoto]  = useState(null);

  const featuredPhoto = ALL_PHOTOS.find(p => p.featured);

  const filteredPhotos = useMemo(() => {
    const nonFeatured = ALL_PHOTOS.filter(p => !p.featured);
    if (activeCategory === 'all') return nonFeatured;
    return nonFeatured.filter(p => p.category === activeCategory);
  }, [activeCategory]);

  const openLightbox  = useCallback((photo) => setSelectedPhoto(photo), []);
  const closeLightbox = useCallback(() => setSelectedPhoto(null), []);

  return (
    <>
      {/* Page Hero */}
      <section className="gallery-hero" aria-labelledby="gallery-hero-heading">
        <div className="gallery-hero__inner">
          <div aria-hidden="true">
            <FaImages size={44} style={{ color: '#C9A84C' }} />
          </div>
          <h1 className="gallery-hero__title" id="gallery-hero-heading">
            NSK Photo Gallery
          </h1>
          <p className="gallery-hero__subtitle">
            Moments from our conferences, training sessions, campus talks,
            youth programmes, and events across Kenya.
          </p>
        </div>
      </section>

      {/* Filter Bar */}
      <nav className="gallery-filters" aria-label="Filter gallery by category">
        <div className="gallery-filters__inner">
          <span className="gallery-filters__label">Filter:</span>
          {CATEGORIES.map(({ id, label }) => (
            <button
              key={id}
              className={`gallery-filter-btn ${activeCategory === id ? 'active' : ''}`}
              onClick={() => setActiveCategory(id)}
              aria-pressed={activeCategory === id}
              aria-label={`Filter by ${label}`}
            >
              {label}
            </button>
          ))}
        </div>
      </nav>

      {/* Gallery Content */}
      <section className="gallery-content" aria-labelledby="gallery-content-heading">
        <div className="gallery-content__inner">

          {/* Featured photo */}
          {activeCategory === 'all' && featuredPhoto && (
            <div
              className="gallery-featured"
              onClick={() => openLightbox(featuredPhoto)}
              role="button"
              tabIndex={0}
              aria-label={`View featured album: ${featuredPhoto.title}`}
              onKeyDown={e => e.key === 'Enter' && openLightbox(featuredPhoto)}
            >
              <div
                className="gallery-featured__bg"
                style={{
                  backgroundImage:    `url(${featuredPhoto.images[0]})`,
                  backgroundSize:     'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat:   'no-repeat',
                }}
                aria-hidden="true"
              />
              <div className="gallery-featured__overlay" aria-hidden="true" />
              <span className="gallery-featured__badge">Featured Album</span>
              <div className="gallery-featured__zoom" aria-hidden="true">
                <FaSearchPlus size={18} />
              </div>
              <div className="gallery-featured__info">
                <span className="gallery-featured__tag">
                  {CATEGORIES.find(c => c.id === featuredPhoto.category)?.label}
                </span>
                <h2 className="gallery-featured__title">
                  {featuredPhoto.title}
                </h2>
                <div className="gallery-featured__meta">
                  <time>{featuredPhoto.date}</time>
                  <span>·</span>
                  <span>{featuredPhoto.images.length} photo{featuredPhoto.images.length === 1 ? '' : 's'}</span>
                </div>
              </div>
            </div>
          )}

          {/* Grid header */}
          <div className="gallery-grid__header">
            <h2 className="gallery-grid__title" id="gallery-content-heading">
              {activeCategory === 'all'
                ? 'All Albums'
                : `${CATEGORIES.find(c => c.id === activeCategory)?.label} Albums`}
            </h2>
            <span className="gallery-grid__count">
              {filteredPhotos.length}{' '}
              {filteredPhotos.length === 1 ? 'album' : 'albums'}
            </span>
          </div>

          {/* Photo grid */}
          <div className="gallery-grid" role="list">
            {filteredPhotos.length > 0 ? (
              filteredPhotos.map(photo => (
                <div role="listitem" key={photo.id}>
                  <article
                    className="gallery-card"
                    onClick={() => openLightbox(photo)}
                    onKeyDown={e => e.key === 'Enter' && openLightbox(photo)}
                    tabIndex={0}
                    role="button"
                    aria-label={`View album: ${photo.title}`}
                  >
                    <div
                      className="gallery-card__image"
                      style={{
                        backgroundImage:    `url(${photo.images[0]})`,
                        backgroundSize:     'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat:   'no-repeat',
                      }}
                      role="img"
                      aria-label={photo.title}
                    >
                      <div className="gallery-card__image-overlay">
                        <div className="gallery-card__zoom-icon">
                          <FaSearchPlus size={28} />
                        </div>
                      </div>
                    </div>

                    <div className="gallery-card__body">
                      <span className="gallery-card__tag">
                        {CATEGORIES.find(c => c.id === photo.category)?.label}
                      </span>
                      <h3 className="gallery-card__title">{photo.title}</h3>
                      <time className="gallery-card__date">
                        {photo.date} · {photo.images.length} photo{photo.images.length === 1 ? '' : 's'}
                      </time>
                    </div>
                  </article>
                </div>
              ))
            ) : (
              <div className="gallery-empty">
                <div aria-hidden="true">
                  <FaImages
                    size={48}
                    style={{ color: 'var(--color-grey-mid)', margin: '0 auto' }}
                  />
                </div>
                <h3 className="gallery-empty__title">No albums found</h3>
                <p className="gallery-empty__text">
                  No photos in this category yet. Check back soon.
                </p>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* CTA Banner */}
      <section className="gallery-cta" aria-labelledby="gallery-cta-heading">
        <div className="gallery-cta__inner">
          <h2 className="gallery-cta__title" id="gallery-cta-heading">
            Want to Be Part of Our <span>Story?</span>
          </h2>
          <p className="gallery-cta__text">
            Join NSK and participate in conferences, workshops, campus talks,
            youth programmes, and outreach across Kenya.
          </p>
          <Link to="/join" className="btn btn--primary">
            Join NSK Today
            <FaArrowRight size={14} aria-hidden="true" style={{ marginLeft: '0.5rem' }} />
          </Link>
        </div>
      </section>

      {/* Lightbox */}
      {selectedPhoto && (
        <Lightbox
          photo={selectedPhoto}
          onClose={closeLightbox}
        />
      )}
    </>
  );
}

export default Gallery;